import { ListItem } from "./item";
import { StoreModel } from "src/graphql/generated/graphql";
import styles from '../map.module.css';
import { useDeviceContext } from 'src/context/device.context';
import { Button } from '@otp/ui';
import { RightArrow, LeftArrow } from '@otp/icons';

interface CardsListProps {
  stores?: Partial<StoreModel>[];
  onItemSelect?: (store: Partial<StoreModel>) => void;
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
}

export const CardsList = ({
  stores,
  onItemSelect,
  isExpanded,
  setIsExpanded,
}: CardsListProps) => {
  const { isMobile } = useDeviceContext();

  const displayList = isMobile === false || isExpanded;
  const displayButton = isMobile === true;

  if (!stores) {
    return null;
  }

  return (
    <div className="relative">
      {displayList && (
        <div className={styles.leftCardsContainer}>
          {stores.map((store) => (
            <ListItem
              store={store}
              key={store.id}
              onClick={onItemSelect ? () => onItemSelect(store) : undefined}
            />
          ))}
        </div>
      )}
      {displayButton && (
        <Button
          variant="outlined"
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            position: 'absolute',
            minWidth: 'auto',
            zIndex: 1,
            top: isExpanded ? 0 : 10,
            right: isExpanded ? -20 : -50,
            backgroundColor: 'var(--mui-palette-primary-200)',
          }}
        >
          {isExpanded ? <LeftArrow /> : <RightArrow />}
        </Button>
      )}
    </div>
  );
};
